import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {DepotModel} from "../models/depot.model";

export const DepotsChannelActions = createActionGroup({
  source: '[Depot/Channel]',
  events: {
    subscribe: props<{ids?: string[]}>(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: DepotModel }>(),
  },
});

export const DepotsAPIActions = createActionGroup({
  source: '[Depot/API]',
  events: {

    //Get infinite scroll Depots
    getInfiniteScrollDepots: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollDepotsSuccess: props<{ depots: DepotModel[], cursor?: string, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollDepotsFailure: props<{ error: any }>(),

    //Get depots
    getDepots: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getDepotsSuccess: props<{ depots: DepotModel[], isSubscribeToChannel?: boolean }>(),
    getDepotsFailure: props<{ error: any }>(),

    //Get depot
    getDepot: props<{ id: string, isSubscribeToChannel?: boolean }>(),
    getDepotSuccess: props<{ depot: DepotModel, isSubscribeToChannel?: boolean }>(),
    getDepotFailure: props<{ error: any }>(),

    //Create Depot
    createDepot: props<{ depot: DepotModel }>(),
    createDepotSuccess: props<{ depot: DepotModel }>(),
    createDepotFailure: props<{ error: any }>(),

    //Update Depot
    updateDepot: props<{ id: string, depot: DepotModel }>(),
    updateDepotSuccess: props<{ depot: DepotModel }>(),
    updateDepotFailure: props<{ error: any }>(),

    //Delete Depot
    deleteDepot: props<{ id: string, shouldMask?: boolean }>(),
    deleteDepotSuccess: props<{ depot: DepotModel }>(),
    deleteDepotFailure: props<{ error: any }>()

  },
});

export const DepotsActions = createActionGroup({
  source: '[Depot]',
  events: {
    setInfiniteScrollDepotIds: props<{ depotIds: string[], isAppendFirst?: boolean }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});
